import { render, staticRenderFns } from "./dialogConsumerInfo.vue?vue&type=template&id=13d82435&"
import script from "./dialogConsumerInfo.vue?vue&type=script&lang=js&"
export * from "./dialogConsumerInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogConsumerInfo.vue?vue&type=style&index=0&id=13d82435&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports